import { useQuery } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type { JobPosition } from '../types/jobPosition.types';
import { JobPositionId } from '@/shared/types/branded.types';

interface UseJobPositionReturn {
  jobPosition: JobPosition | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useJobPosition(id: string | undefined): UseJobPositionReturn {
  const query = useQuery({
    queryKey: ['job-position', id],
    queryFn: () => jobPositionService.getById(JobPositionId(id!)),
    enabled: !!id,
  });

  return {
    jobPosition: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
